require('bootstrap-datepicker/js/bootstrap-datepicker.js');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.ja.js');
